import script from "./LandingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandingPage.vue?vue&type=script&setup=true&lang=ts"

import "./LandingPage.vue?vue&type=style&index=0&id=449f068e&lang=less&scoped=true"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-449f068e"]])

export default __exports__